import React from "react";
import {
 Box,
 Heading,
 Accordion,
 AccordionItem,
 AccordionButton,
 AccordionPanel,
 AccordionIcon,
} from "@chakra-ui/react";

const DeemedFAQsSection = ({ faqs }) => {
 if (!faqs || faqs.length === 0) {
  return null;
 }

 return (
  <Box mb={8}>
   <Heading as="h2" size="md" mb={4}>
    Frequently Asked Questions
   </Heading>

   <Accordion allowMultiple borderRadius="md" boxShadow="sm">
    {faqs.map((faq, index) => (
     <AccordionItem key={index} border="1px" borderColor="gray.200">
      <h3>
       <AccordionButton py={3} _expanded={{ bg: "gray.100" }}>
        <Box flex="1" textAlign="left" fontWeight="medium">
         {faq.question}
        </Box>
        <AccordionIcon />
       </AccordionButton>
      </h3>
      <AccordionPanel pb={4}>{faq.answer}</AccordionPanel>
     </AccordionItem>
    ))}
   </Accordion>
  </Box>
 );
};

export default DeemedFAQsSection;
